import React, { Component } from 'react';
import { DropdownButton, MenuItem} from 'react-bootstrap';

export class FirstModel extends Component {
    displayName = FirstModel.name

    constructor(props) {
        super(props);
        this.state = {
            currentCount: 0,
            name: "",            
            category: "Без категории",          
            chapter: "Новости",
            tag: "тег",
            result: "",
            loading: false,
            button: "Результаты"
        };
        this.incrementCounter = this.incrementCounter.bind(this);
        this.setName = this.setName.bind(this);
        this.setCategory = this.setCategory.bind(this);
        this.setChapter = this.setChapter.bind(this);
        this.getResult = this.getResult.bind(this);
        this.setTag = this.setTag.bind(this);
    }

    incrementCounter() {
        this.setState({
            currentCount: this.state.currentCount + 1
        });
    }
    setName(str) {       
        this.setState({ name: str });
    }
    setCategory(str) {       
        this.setState({ category: str });
    }
    setChapter(str) {
        this.setState({ chapter: str });
    }
    setTag(str) {
        this.setState({ tag: str });
    }
    getResult() {
        this.setState({ loading: true, button: "..progress" });

        fetch('api/model/First', {
            method: 'post',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                name: this.state.name,
                core: this.state.core,
                category: this.state.category,
                chapter: this.state.chapter,
                tag: this.state.tag
            })
        }).then(response => response.json())
            .then(data => {
                this.setState({ result: data.result, loading: false, button: "Результаты" });
            });
    }    

    render() {    

        return (
            <div className="col-md-11">
                <h1>Прогнозная модель</h1>
                <h3>TF-IDF</h3>           
                <div className="row form-group">
                    <textarea name="name" placeholder="Название" className="form-control" type="text" value={this.state.name} onChange={(e) => this.setName(e.target.value)}></textarea>
                </div>
                <div className="row form-group">
                    <div className="col-md-1">
                        <h4>Категория:</h4>
                    </div>
                    <div className="col-md-1">
                        <DropdownButton title={this.state.category}>
                            <MenuItem onClick={(e) => this.setCategory("Без категории")}>Без категории</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Происшествия")}>Происшествия</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Личные финансы")}>Личные финансы</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("В мире")}>В мире</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Технологии")}>Технологии</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Спорт")}>Спорт</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Наука")}>Наука</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Культура")}>Культура</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Регионы")}>Регионы</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Шоубиз")}>Шоубиз</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Эксклюзивы")}>Эксклюзивы</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Авто")}>Авто</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Армия")}>Армия</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Политика")}>Политика</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Общество")}>Общество</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Здоровье")}>Здоровье</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("История")}>История</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Россия")}>Россия</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Экономика")}>Экономика</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Коронавирус")}>Коронавирус</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Криминал")}>Криминал</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Поп-культура и Развлечения")}>Поп-культура и Развлечения</MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Наука и Технологии ")}>Наука и Технологии </MenuItem>
                            <MenuItem onClick={(e) => this.setCategory("Интересное ")}>Интересное </MenuItem>               
                        </DropdownButton>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-1">
                        <h4>Раздел:</h4>
                    </div>
                    <div className="col-md-1">
                        <DropdownButton title={this.state.chapter}>
                            <MenuItem onClick={(e) => this.setChapter("Новости")}>Новости</MenuItem>
                            <MenuItem onClick={(e) => this.setChapter("Расследования")}>Расследования</MenuItem>
                            <MenuItem onClick={(e) => this.setChapter("Статьи")}>Статьи</MenuItem>
                            <MenuItem onClick={(e) => this.setChapter("Wow")}>Wow</MenuItem>
                            <MenuItem onClick={(e) => this.setChapter("Дичь")}>Дичь</MenuItem>                     
                        </DropdownButton>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-md-1">
                        <h4>Тег:</h4>
                    </div>
                    <div className="col-md-1">
                        <DropdownButton title={this.state.tag}>
                            <MenuItem onClick={(e) => this.setTag("Тег")}>Тег</MenuItem>
                            <MenuItem onClick={(e) => this.setTag("Тег")}>Тег</MenuItem>
                            <MenuItem onClick={(e) => this.setTag("Тег")}>Тег</MenuItem>
                            <MenuItem onClick={(e) => this.setTag("Тег")}>Тег</MenuItem>
                            <MenuItem onClick={(e) => this.setTag("Тег")}>Тег</MenuItem>
                        </DropdownButton>
                    </div>
                </div>
                <button className="button" onClick={this.getResult} disabled={this.state.loading}>{this.state.button}</button>
                <br></br>
                <div className="row form-group" style={{ marginTop: '40px' }}>                 
                    <textarea name="name" placeholder="Результаты" rows="10" className="form-control" type="text" value={this.state.result} ></textarea>                   
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/FirstModel.js